import { Link } from '../lib/router';
import { cx } from './ui';
import type { OrderProblem } from './useOrderForm';

/** What stops the order, under the blank submit button: a title, how to fix it, and an optional link. */
export function OrderProblemNote({ problem, className }: { problem: OrderProblem; className?: string }) {
  return (
    <div role="alert" className={cx('flex gap-2 rounded-lg border border-warn/40 bg-warn-bg px-3 py-2 text-left text-xs leading-normal text-fg', className)}>
      <span aria-hidden="true" className="font-bold text-warn">
        !
      </span>
      <p className="m-0 min-w-0">
        <b className="block font-semibold text-warn">{problem.title}</b>
        {problem.text}
        {problem.link && (
          <>
            {' '}
            <Link to={problem.link.to} className="font-semibold text-accent-fg hover:underline">
              {problem.link.label}
            </Link>
          </>
        )}
      </p>
    </div>
  );
}

/** The submit button's look: the side's colour when the order can go, a blank dashed outline when it cannot. */
export const ctaTone = (side: 'long' | 'short', blocked: boolean) =>
  blocked ? 'border-[1.5px] border-dashed border-line-strong bg-transparent text-muted' : side === 'long' ? 'bg-btn-long text-btn-long-fg' : 'bg-btn-short text-btn-short-fg';
